import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.push.js";
import { mapGetters } from 'vuex';
export default {
  methods: {
    goTo: function goTo() {
      if (this.snackbar.href) {
        this.$router.push(this.snackbar.href);
      }
    }
  },
  computed: _objectSpread({}, mapGetters('snackbar', {
    snackbar: 'getSnackbarInstance'
  }))
};